<template>
  <div>
    <div class="top">
      <div class="nav">
        <a href="https://omniesk8.com/" target="_blank">
          <img
            src="@/assets/images/esk/omniesk8-logo.png"
            alt=""></a>
        <a href="https://omniesk8.com/" target="_blank">Home</a>
        <router-link to="calc.html">Esk8 Calculator</router-link>
        <router-link to="belt.html">Belt Calculator</router-link>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.top {
  background: #000;

  .nav {
    width: 80%;
    margin: auto;
    display: flex;
    justify-content: flex-start;
  }

  a {
    width: 15%;
    color: #fff;
    text-align: center;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background: orange;
      text-decoration: underline;
    }

    img {
      width: 100%;
      max-width: 150px;
    }
  }
}

@media (max-width: 1001px) {
  .top {
    .nav {
      width: 90%;
      justify-content: space-around;
      height: 60px;
    }
  }
}

@media (min-width: 1600px) {
  .top {
    .nav {
      width: 70%;
      justify-content: flex-start;
      //height: 60px;
    }
  }
}
</style>
<script>
export default {
  name: 'Header'
}
</script>
